import zenObservable from 'zen-observable';
export var Observable = zenObservable;
//# sourceMappingURL=zenObservable.js.map


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/zen-observable-ts/lib/zenObservable.js
// module id = 286
// module chunks = 0